import DotcomSharedComponentsLayout from '~/src/layouts/dotcom-shared-components-layout';
import * as React from 'react';
export default {
  DotcomSharedComponentsLayout,
  React
};